import { z } from 'zod';
/**
 * Export payload. Todos/tags are intentionally loose on read (old export files
 * round-trip through import), while the server always emits canonical shapes.
 */
export const exportPayloadSchema = z.object({
    exportedAt: z.iso.datetime({ offset: true }),
    user: z
        .object({
        id: z.string(),
        email: z.string().nullable(),
        profile: z.record(z.string(), z.unknown()).nullable(),
        settings: z.record(z.string(), z.unknown()).nullable(),
    })
        .loose(),
    todos: z.array(z.record(z.string(), z.unknown())),
    tags: z.array(z.record(z.string(), z.unknown())),
    stats: z.record(z.string(), z.unknown()),
    // Daily-plan data (added later): OPTIONAL so old export files stay
    // importable — and declared here because the import parse strips unknown
    // keys, which would otherwise silently drop plans on a round-trip.
    dailyPlans: z
        .array(z.object({ date: z.string(), data: z.record(z.string(), z.unknown()) }))
        .optional(),
    dailyPlanSettings: z.record(z.string(), z.unknown()).nullable().optional(),
});
export const importRequestSchema = z.object({
    /** Export payload as object, or a JSON string of it (old export files). */
    data: z.union([z.string().min(1), z.record(z.string(), z.unknown())]),
    mode: z.enum(['merge', 'replace']).default('merge'),
});
export const importResponseSchema = z.object({
    importedCount: z.number().int().min(0),
});
export const exportQuerySchema = z.object({
    format: z.enum(['json', 'csv']).default('json'),
});
//# sourceMappingURL=export-import.js.map